import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { CommonControlsPropsAPI } from '../../components/api';
export const _frontmatter = {
  "Title": "Pre-defined types"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "pre-defined-control-types"
    }}>{`Pre-defined control types`}</h1>
    <p>{`If you want more than the default timer, the next simpler way is to pass a `}<inlineCode parentName="p">{`controls`}</inlineCode>{` property to your `}<inlineCode parentName="p">{`Model`}</inlineCode>{`.`}</p>
    <p>{`By doing so, you can use one or more of the `}<em parentName="p">{`pre-defined control types`}</em>{`.`}</p>
    <p>{`These control types are:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-sim/controls/checkbox"
        }}>{`Checkbox`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-sim/controls/input"
        }}>{`Input`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-sim/controls/toggle"
        }}>{`Toggle`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-sim/controls/radio"
        }}>{`Radio`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-sim/controls/select"
        }}>{`Select`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-sim/controls/range"
        }}>{`Range`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-sim/controls/timer"
        }}>{`Timer`}</a></li>
    </ul>
    <p>{`The `}<inlineCode parentName="p">{`controls`}</inlineCode>{` props can be:`}</p>
    <ul>
      <li parentName="ul">{`an object, in which case you are specifying a single control, or`}</li>
      <li parentName="ul">{`an array, which is how you can `}<a parentName="li" {...{
          "href": "/react-sim/controls/arranging-controls"
        }}>{`arrange controls`}</a></li>
    </ul>
    <h1 {...{
      "id": "common-props"
    }}>{`Common props`}</h1>
    <p>{`All controls, except the `}<inlineCode parentName="p">{`Timer`}</inlineCode>{`, have the following props -`}</p>
    <CommonControlsPropsAPI mdxType="CommonControlsPropsAPI" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      